<template>
  <div style="width:100%;height:100%">
    <div class="sky-user-info">
      <div class="user-info-content">
        <div class="user-info-item wsp-display-flex">
          <div class="user-info-item-label">姓名：</div>
          <div class="user-info-item-value">{{ userInfo.userName }}</div>
        </div>
        <div class="user-info-item wsp-display-flex">
          <div class="user-info-item-label">真实姓名：</div>
          <div class="user-info-item-value">{{ userInfo.realName }}</div>
        </div>
        <div class="user-info-item">
          <div class="user-info-item-label">手机号码：</div>
          <div class="user-info-item-value">{{ userInfo.telephoneNum }}</div>
        </div>
        <div class="user-info-item">
          <div class="user-info-item-label">邮箱：</div>
          <div class="user-info-item-value">{{ userInfo.email }}</div>
        </div>
        <div class="user-info-item">
          <div class="user-info-item-label">账号状态：</div>
          <div class="user-info-item-value">
            <el-tag v-if="userInfo.enabled" type="success">可用</el-tag>
            <el-tag v-else type="danger">不可用</el-tag>
          </div>
        </div>
        <div class="user-info-item">
          <div class="user-info-item-label">审批状态：</div>
          <div class="user-info-item-value">
            <sk-icon-status
              v-if="userInfo.approvalStatus === 'APPROVED'"
              type="success"
              content="通过"
            ></sk-icon-status>
            <sk-icon-status
              v-else-if="userInfo.approvalStatus === 'REJECTED'"
              type="error"
              content="不通过"
            ></sk-icon-status>
            <sk-icon-status
              v-else-if="userInfo.approvalStatus === 'PENDING'"
              type="ing"
              content="审批中"
            ></sk-icon-status>
          </div>
        </div>
        <div class="user-info-item" v-if="userInfo.approvalStatus === 'REJECTED'">
          <div class="user-info-item-label">审批意见：</div>
          <div class="user-info-item-value bg-red wsp-word-break ">{{ userInfo.comment }}</div>
        </div>
        <div class="user-info-item">
          <div class="user-info-item-label">注册时间：</div>
          <div class="user-info-item-value">{{ userInfo.createTimeCh }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Form, Input, Button, Tooltip, Tag } from 'element-ui'
import { SkIconStatus } from 'sk-ui'

import { timestampToTime } from '@/utils/timeUtil'

export default {
  name: 'userInfo',
  components: {
    [Form.name]: Form,
    [Input.name]: Input,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    [Tag.name]: Tag,
    [SkIconStatus.name]: SkIconStatus
  },
  data() {
    return {
      userInfo: {}
    }
  },
  created() {
    this.userInfo = this.$store.getters.baseInfo
    this.userInfo.createTimeCh = timestampToTime(this.userInfo.createTime)
    // if (!this.userInfo.approvalStatus) {
    //   this.$router.push({ path: '/help' })
    // }
    // if (this.userInfo.approvalStatus && this.userInfo.approvalStatus === 'APPROVED') {
    //   this.$router.push({ path: '/help' })
    // }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {}
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/mixin/mixin';
@import '~sky-engine/assets/styles/common/var.scss';
@include b(user-info) {
  display: flex;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
  .user-info-content {
    width: 50%;
    line-height: 48px;
    .user-info-item {
      display: flex;
      .user-info-item-label {
        width: 20%;
        text-align: right;
      }
      .user-info-item-value {
        width: 80%;
      }
    }
  }
}
</style>
